<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
            :headers="headers"
            :items="translatedCategories"
            :search="search"
            :rows-per-page-items='[{"text":"All","value":-1}]'
            disable-initial-sort
            class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.translation">{{ props.item.translation.name }}</span>
          <span class="red--text" v-if="!props.item.translation">no translation</span>
        </td>
        <td class="text-xs-left">
          <RowImage :src-set="props.item.translation ? props.item.translation.imageSet : null" :backup-set="props.item.imageSet" />
        </td>
        <td class="justify-center layout px-0">
          <v-icon
                  small
                  class="mr-2"
                  @click="$emit('edit', props.item)"
          >
            edit
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="errorOnLoad" color="error">
          Произошла ошибка при получении данных :(
        </v-alert>
        <div v-if="!errorOnLoad">No data</div>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import RowImage from './RowImage'

export default {
  components: { RowImage },
  data () {
    return {
      search: '',
      errorOnLoad: null,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Translation', value: 'translation.name' },
        { text: 'Image', value: 'image' },
        { text: 'Actions', value: 'id', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState([
      'translatedCategories'
    ])
  }
}
</script>
